import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/'
import nprogress from 'nprogress/nprogress'

import Auth from '@/views/auth/Auth'
import Callback from '@/views/auth/Callback'
import Login from '@/views/auth/Login'
import Logout from '@/views/auth/Logout'

import RequestExams from '@/views/RequestExams'
import DemoExams from '@/views/DemoExams'
import ExamsLogs from '@/views/ExamsLogs'
import Orgs from '@/views/Orgs'
import DeCenter from '@/views/DeCenter'
import DeCenterNew from '@/views/DeCenterNew'
import ExamGroups from '@/views/ExamGroups'
import Groups from '@/views/Groups'
import DeCenterDetail from '@/views/DeCenterDetail'

import PageNotFound from '@/views/PageNotFound'
import Reports from '@/views/Reports'
import Experts from '@/views/Experts'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/requests'
    },
    {
      path: '/requests',
      component: RequestExams,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_education_ministry',
          'front_dep',
          'front_admin',
          'front_curator',
          'front_curator_institution'
        ]
      }
    },
    {
      path: '/orgs',
      component: Orgs,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_admin',
          'front_curator',
          'front_curator_institution'
        ]
      }
    },
    {
      path: '/de-center',
      component: DeCenter,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_curator',
          'front_assessor',
          'front_curator_institution',
          'front_auditor'
        ]
      }
    },
    {
      path: '/de-center/new',
      component: DeCenterNew,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_curator',
          'front_curator_institution'
        ]
      }
    },
    {
      path: '/de-center/:id',
      component: DeCenterDetail,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_curator',
          'front_assessor',
          'front_curator_institution',
          'front_auditor'
        ]
      }
    },
    {
      path: '/demo-exams',
      component: DemoExams,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_me',
          'front_mc',
          'front_mio',
          'front_50plus',
          'front_curator',
          'front_curator_institution',
          'front_le',
          'front_tech_expert',
          'front_auditor'
        ]
      }
    },
    {
      path: '/demo-exams/:id',
      component: ExamGroups,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_me',
          'front_mc',
          'front_mio',
          'front_50plus',
          'front_curator',
          'front_curator_institution',
          'front_le',
          'front_tech_expert',
          'front_auditor'
        ]
      }
    },
    {
      path: '/demo-exams/:id/logs',
      component: ExamsLogs,
      meta: {
        requiresAuth: true,
        only: [
          'front_admin',
          'front_dep'
        ]
      }
    },
    {
      path: '/orgs/:id/groups',
      name: 'groups',
      component: Groups,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_curator',
          'front_curator_institution'
        ]
      }
    },
    {
      path: '/reports',
      component: Reports,
      meta: {
        requiresAuth: true,
        only: [
          'front_dep',
          'front_education_ministry',
          'front_admin',
          'front_rcc',
          'front_mc'
        ]
      }
    },
    {
      path: '/experts',
      component: Experts,
      meta: {
        requiresAuth: true,
        only: [
          'front_rcc',
          'front_university',
          'front_dep',
          'front_admin',
          'front_curator',
          'front_curator_institution'
        ]
      }
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
      meta: { requiresAuth: false }
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: { requiresAuth: false }
    },
    {
      path: '*',
      component: PageNotFound
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  nprogress.start()
  if (to.matched.some(record => record.meta.requiresAuth === true)) {
    if (store.getters['authentication/isAuthenticated']) {
      if (!store.state['authentication'].user) {
        try {
          await store.dispatch('authentication/populateUser')
        } catch (e) {
          if (e.message === 'empty-data') {
            return window.location.reload()
          }
          if (e && e.code === 403) {
            console.log(e)
            return window.location.replace(`/login`)
          }
        }
      }
      if (to.meta && to.meta.only) {
        if (to.meta.only.indexOf(store.state['authentication'].currentRole) < 0) {
          let redirectTo = null
          for (const route of router.options.routes) {
            if (route.meta && route.meta.only) {
              if (route.meta.only.indexOf(store.state['authentication'].currentRole) > -1) {
                redirectTo = route.path
                break
              }
            }
          }
          if (redirectTo) {
            return next(redirectTo)
          } else {
            window.location.replace(`/login`)
          }
        }
      }
    } else {
      window.location.replace(`/login`)
    }
  }
  next()
})

router.afterEach(() => {
  nprogress.done()
})

export default router
